var careers = new function () {
    this.cache = {};
    this.doLoad = function (event, el) {
        var $el = $(el),
            $main = $(el).closest('.careers__list__wrapper');
        if ($el.is('select') || $el.is('a') || $el.is('button')) {
            if ($el.data('page')) {
                $main.find('.careers-page').val($el.data('page'));
            }
            if (!$main.hasClass('careers__list__wrapper--block')) {
                listFilter.doStateChange();
            }
        }
        this.doAjaxLoad();
    };
    this.setLoading = function (loading) {
        listFilter.doScrollTop();
        $('.careers-list')[(loading ? 'add' : 'remove') + 'Class']('loading');
        $('.careers-location, .careers-category, .careers-search').prop('disabled', loading);
        if (!loading) {
            $('.careers-category-wrapper, .careers-list').removeClass('hide');
            $('.careers-category-list').addClass('hide');
        }
    };
    this.doAjaxLoad = function () {
        var $careersList = $('.careers-list'),
            ajaxData = {
                action: 'flogas_careers_get',
                category: $('.careers-category').val(),
                location: $('.careers-location').val(),
                page: $('.careers-page').val(),
                _wpnonce: $careersList.data('nonce')
            },
            cacheKey = ajaxData.keyword + ':' + ajaxData.category + ':' + ajaxData.location + ':' + ajaxData.page;
        careers.setLoading(true);
        if (typeof careers.cache[cacheKey] != 'undefined') {
            $careersList.html(careers.cache[cacheKey]);
            careers.setLoading(false);
            data.setCss();
        } else {
            if (typeof this.xhr == 'object') this.xhr.abort();
            this.xhr = $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                dataType: 'json',
                data: ajaxData,
                success: function (json) {
                    careers.cache[cacheKey] = json.data;
                    careers.setLoading(false);
                    $careersList.html(json.data);
                }
            });
        }
    };
    this.doKeyup = function (event, el) {
        var keyCode = (event.keyCode ? event.keyCode : event.which);
        if (keyCode == 13) {
            event.preventDefault();
            $('.careers-search').trigger('click');
        }
    };
    this.doResetFilters = function (event, el) {
        $('.careers-category, .careers-location').val('');
        $('.careers-category').trigger('change');
    };
    this.doSubmit = function (event, el) {
        let newUrl = '/careers-results',
            category = $(el).find('.careers-category').val()?.filter((value) => value !== ''),
            location = $(el).find('.careers-location').val()?.filter((value) => value !== '');
        if (category && category.length) newUrl += '/category/' + category.sort().join(',');
        if (location && location.length) newUrl += '/location/' + location.sort().join(',');
        window.location = newUrl;
    };
    this.doLoadMap = function (event, el) {
        var position = {lat: 54.8626283, lng: -2.4514198},
            mapStyle = [
                {
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.neighborhood",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                }
            ],
            map = new google.maps.Map(document.getElementById('careers-map'), {
                center: position,
                zoom: 6,
                styles: mapStyle,
                streetViewControl: false,
                fullscreenControl: false,
                mapTypeControl: false,
                mapTypeControl: false,
                zoomControl: false,
                draggable: false,
            }),
            marker;
            if (typeof this.xhr == 'object') this.xhr.abort();
            this.xhr = $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                dataType: 'json',
                data: {
                    action: 'flogas_careers_map_get',
                    _wpnonce: $('.careers-map').data('nonce')
                },
                success: function (json) {
                    $.each(json.data, function (key, value) {
                        marker = new google.maps.Marker({
                            position: {lat: value.lat, lng: value.lon},
                            map: map,
                            icon: '/images/icon/maps/map-pin-careers.png',
                            title: value.title
                        });
                    });
                }
            });
    };
    this.doShareUrlSelectAll = function (event, el) {
        el.select();
    }
    this.doCopyShareUrl = function (event, el) {
        console.log('Share button copied');
        $('#career-share-url').select();
        document.execCommand('copy');
        $('.careers-single-sharelink__button').text('Copied!').prop('disabled', true);
        setTimeout(function() {
            $('.careers-single-sharelink__button').text('Copy link').prop('disabled', false);
        }, 1000);
    };
    /*this.resizeDescriptionIFrame = function (event) {
        const $iframe = $('.careers-single__description iframe');
        $iframe.css('height', Math.ceil($iframe[0].contentDocument.documentElement.getBoundingClientRect().height) + 'px');
    }*/
};
$(function () {
    if ($('.careers-map').length) {
        careers.doLoadMap();
    }
    /*let careersDescriptionIFrame = $('.careers-single__description iframe');
    if (careersDescriptionIFrame.length) {
        addEventListener('load', careers.resizeDescriptionIFrame);
        careersDescriptionIFrame[0].contentWindow.addEventListener('resize', careers.resizeDescriptionIFrame);
    }*/
});
if (typeof listFilter != 'undefined') {
    listFilter.setPageClass('.careers-page');
    listFilter.setVariables({
        category: {prefix: 'category', identifier: '.careers-category'},
        location: {prefix: 'location', identifier: '.careers-location'}
    });
    window.onpopstate = function (event) {
        listFilter.setParamsFromUrl();
        careers.doAjaxLoad();
    };
}